import React from 'react';
import { CheckIcon } from 'lucide-react';
interface ChipGroupProps {
  legend: string;
  options: string[];
  value?: string;
  onSelect: (option: string) => void;
  children?: React.ReactNode;
}
export function ChipGroup({
  legend,
  options,
  value,
  onSelect,
  children
}: ChipGroupProps) {
  return <fieldset className="rounded-3xl border border-line bg-paper p-5 hc-strong" data-id="element-505" data-mp="1m0qbkr7lo93e">
      <legend className="sr-only" data-id="element-506" data-mp="29quail9ufko2">{legend}</legend>
      <p aria-hidden="true" className="font-display text-xl font-semibold text-forest" data-id="element-507" data-mp="29rdk9epcb2r0">
        {legend}
      </p>
      <div className="mt-3 flex flex-wrap gap-2" data-id="element-508" data-mp="2ep5l4y7ypz7c">
        {options.map(option => {
        const selected = value === option;
        return <button key={option} type="button" aria-pressed={selected} onClick={() => onSelect(option)} className={`inline-flex min-h-[44px] items-center gap-1.5 rounded-full border px-4 py-2 text-left transition-colors duration-150 ease-out hc-strong ${selected ? 'border-teal bg-teal text-white' : 'aero-pill border-line text-ink hover:bg-sand'}`} data-id="element-509" data-mp="24qzmqqld7b78">
              {selected && <CheckIcon size={16} aria-hidden="true" data-id="element-510" data-mp="1m2zfldqt8w2z" />}
              {option}
            </button>;
      })}
      </div>
      {children}
    </fieldset>;
}